import { InboxIcon } from '@/components/icons/registry';
import { StateBlock, type StateProps } from '@/components/ui/state-block';

/**
 * A lista não tem nada — e isso **não é um erro**.
 *
 * Existe porque o app vinha desenhando o vazio de três jeitos diferentes: um
 * `Callout variant="info"` com título em `/alerts`, um `<Text tone="muted">`
 * solto em `/donations`, e um `Callout` sem título em `/calls`. Três formas
 * para o mesmo estado, e nenhuma delas com peso visual suficiente para a
 * pessoa entender que a tela **terminou de carregar**.
 *
 * ⚠️ **Não use para erro.** O ícone e o tom aqui dizem "está tudo bem, só não
 * há nada", e a maioria dos vazios deste app é estado saudável — "nenhum
 * alerta ativo" é uma boa notícia. Falha de carregamento é `ErrorState`, que
 * tem a mesma API justamente para a troca ser de uma palavra.
 *
 * @example
 * <EmptyState
 *   title="Nenhum alerta ativo"
 *   description="Quando a Defesa Civil publicar um alerta, ele aparece aqui."
 * />
 */
export function EmptyState(props: StateProps) {
  return <StateBlock defaultIcon={InboxIcon} {...props} />;
}
